// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__TaJw4","inner":"Form_inner__34snz","range":"Form_range__KB9RO","name":"Form_name__3Dgn7","actions":"Form_actions___loQx"};